import React from 'react'

function LinkExpired() {
    
  return (
    <div className="container-fluid d-flex align-items-center justify-content-center vh-100 bg-light">
    <div className="text-center p-4 rounded bg-white shadow-sm" style={{ maxWidth: '500px' }}>
      <h1 className="display-4 text-danger mb-3">Link Expired</h1>
      <p className="lead text-muted mb-4">
        The link you followed has expired or is no longer available. Please try again or contact support if you need assistance.
      </p>
     
    </div>
  </div>
  )
}

export default LinkExpired